import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@/shared/Modal';
import { Button, Text, Title, CenteredColumn } from '@/shared/ui';
import { useAnalytics } from '@/hooks/useAnalytics';
import { Spacing } from '@/shared/theme';
import {
  CANCEL_START_OVER,
  CONFIRM_START_OVER,
} from '@/consts/events';

interface StartOverModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const StartOverModal: React.FC<StartOverModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  const handleConfirm = () => {
    track({ event: CONFIRM_START_OVER });
    onConfirm();
  };

  const handleCancel = () => {
    track({ event: CANCEL_START_OVER });
    onCancel();
  };

  return (
    <Modal open={isOpen} onClose={handleCancel}>
      <CenteredColumn>
        <Title size="h3" centered bold>
          {t('confirm-start-over.title', 'Start Over?')}
        </Title>
      </CenteredColumn>
      <CenteredColumn marginTop={Spacing.x2}>
        <Text size="p1" centered>
          {t(
            'confirm-start-over.subtitle',
            'Going back will clear your progress and return you to the beginning. Are you sure you want to start over?'
          )}
        </Text>
      </CenteredColumn>
      <CenteredColumn marginTop={Spacing.x2}>
        <Button
          size="default"
          variant="action-primary"
          onClick={handleCancel}
          text={t('confirm-start-over.cancel', 'No, Continue')}
        />
      </CenteredColumn>
      <CenteredColumn marginTop={Spacing.x2}>
        <Button
          size="default"
          variant="action-tertiary"
          onClick={handleConfirm}
          text={t('confirm-start-over.confirm', 'Yes, Start Over')}
        />
      </CenteredColumn>
    </Modal>
  );
};
